import { PATHS } from "@/internals/constants/paths";
import { DomainRouteConfig } from "../types";

const publicRoutes = [
  PATHS.HOME,
  PATHS.LOGIN,
  PATHS.SIGNUP,
  PATHS.FORGOT_PASSWORD,
  PATHS.RESET_PASSWORD,
  PATHS.TERMS_AND_CONDITIONS,
  PATHS.TERMS_OF_USE,
  PATHS.PRIVACY_POLICY,
  PATHS.COOKIES_POLICY,
  PATHS.ABOUT_US,
  PATHS.CONTACT_US,
  PATHS.HOW_WE_ARE,
  PATHS.PRICING,
  PATHS.FAQ,
  PATHS.VERIFY_PAYMENT,
  PATHS.INACTIVE,
  PATHS.WHOWEARE,
  PATHS.QR_EDITOR,
];

const initialPrefetchRoutes = [PATHS.HOME, PATHS.LOGIN, PATHS.SIGNUP, PATHS.PRICING];

export const SPECIAL_ROUTES = ["/qr/", "/p/"];

export const defaultConfig: DomainRouteConfig = {
  requiresAuth: false,
  homePath: PATHS.HOME,
  logoLinkEnabled: true,
  authRedirectPath: PATHS.HOME,
  logoutRedirectPath: PATHS.HOME,
  publicRoutes,
  initialPrefetchRoutes,
  abTestConfig: {
    provider: "vwo",
    enabled: false,
    config: {},
  },
};

export const domainConfigs: Record<string, DomainRouteConfig> = {
  localhost: defaultConfig,
  "fastqrgenerator.com": defaultConfig,
  "app.qrnow.com": {
    requiresAuth: true,
    homePath: PATHS.MY_QR_CODES,
    logoLinkEnabled: false,
    authRedirectPath: PATHS.LOGIN,
    logoutRedirectPath: PATHS.LOGIN,
    publicRoutes: publicRoutes.filter((route) => route !== PATHS.QR_EDITOR),
    initialPrefetchRoutes,
    skipPendingActionForUnauth: true,
  },
  "app.onlineqrcode.com": {
    requiresAuth: true,
    homePath: PATHS.QR_EDITOR,
    logoLinkEnabled: true,
    authRedirectPath: PATHS.QR_EDITOR,
    logoutRedirectPath: PATHS.QR_EDITOR,
    publicRoutes: [...publicRoutes, PATHS.QR_EDITOR],
    initialPrefetchRoutes,
  },
  "qrcreator.com": {
    ...defaultConfig,
    initialPrefetchRoutes: [],
    abTestConfig: {
      provider: "vwo",
      enabled: true,
      config: {
        accountId: "116448",
      },
    },
    amplitudeWebExperimentsEnabled: true,
  },
};

export const getDomainConfig = (hostname: string): DomainRouteConfig => {
  const foundConfig = Object.entries(domainConfigs).find(([domain]) =>
    hostname.includes(domain)
  )?.[1];

  return foundConfig ?? defaultConfig;
};
